// Module
var code = "<h3 id=\"signed-up-for-paperless-tax\">Signed up for Paperless Tax</h3> <p>We will email your tax form by the end of January. </p> ";
// Exports
export default code;